module.exports = __webpack_public_path__ + "img/min_6.ae79362c.png";